<template>
  <div>
    <va-inner-loading :loading="loader">
      <va-card class="mb-4">
        <div class="d-flex justify--space-between align--center flex-wrap mb-3">
          <h1 class="ma-0">Временные слоты</h1>
          <div class="d-flex align--center gap-2">
            <div class="filter-select-wrap">
              <label class="va-input__label">Тип доставки</label>
              <select
                v-model="filterTypeId"
                class="form-control form-control--filter"
              >
                <option value="">Все типы</option>
                <option
                  v-for="opt in typeOptionsFilter"
                  :key="opt.value"
                  :value="opt.value"
                >
                  {{ opt.text }}
                </option>
              </select>
            </div>
            <va-button color="info" @click="openCreateModal">
              Добавить слот
            </va-button>
          </div>
        </div>
        <va-data-table
          :fields="fields"
          :data="filteredList"
          class="va-table va-table--hoverable"
        >
          <template slot="time" slot-scope="props">
            {{ formatTime(props.rowData.time_from) }} –
            {{ formatTime(props.rowData.time_to) }}
          </template>
          <template slot="delivery_type" slot-scope="props">
            {{ getTypeTitle(props.rowData.delivery_type_id) }}
          </template>
          <template slot="is_active" slot-scope="props">
            <va-badge
              :text="props.rowData.is_active ? 'Да' : 'Нет'"
              :color="props.rowData.is_active ? 'success' : 'gray'"
            />
          </template>
          <template slot="sort" slot-scope="props">
            <va-button
              flat
              small
              icon="fa fa-arrow-up"
              @click="moveSlot(props.rowData, -1)"
            />
            <va-button
              flat
              small
              icon="fa fa-arrow-down"
              @click="moveSlot(props.rowData, 1)"
            />
          </template>
          <template slot="actions" slot-scope="props">
            <va-button
              flat
              small
              color="gray"
              icon="fa fa-pencil"
              @click="edit(props.rowData)"
            />
            <va-button
              flat
              small
              color="gray"
              icon="fa fa-trash"
              @click="remove(props.rowData.id)"
            />
          </template>
        </va-data-table>
      </va-card>
    </va-inner-loading>

    <va-modal v-model="showModal" hide-default-actions size="medium">
      <template #header>
        <span>{{ editId ? "Редактировать слот" : "Новый слот" }}</span>
      </template>
      <DeliverySlotForm
        :initial="editItem"
        :delivery-types="typeOptions"
        @submit="onSubmit"
        @cancel="closeModal"
      />
    </va-modal>
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from "vuex";
import DeliverySlotForm from "../../components/delivery-management/DeliverySlotForm.vue";

export default {
  name: "DeliverySlots",
  components: { DeliverySlotForm },
  data() {
    return {
      showModal: false,
      editId: null,
      editItem: null,
      filterTypeId: "",
    };
  },
  computed: {
    ...mapState("deliverySlots", ["list"]),
    ...mapGetters({ loader: "isLoading" }),
    typesList() {
      return this.$store.state.deliveryTypes.list || [];
    },
    typeOptions() {
      const list = this.typesList || [];
      return list
        .filter((t) => t.id != null)
        .map((t) => ({ value: Number(t.id), text: t.title || "—" }));
    },
    typeOptionsFilter() {
      return this.typeOptions;
    },
    filteredList() {
      if (this.filterTypeId === "" || this.filterTypeId == null) return this.list;
      return this.list.filter(
        (s) => Number(s.delivery_type_id) === Number(this.filterTypeId)
      );
    },
    fields() {
      return [
        { name: "__slot:time", title: "Время" },
        { name: "__slot:delivery_type", title: "Тип доставки" },
        { name: "__slot:is_active", title: "Активен" },
        { name: "__slot:sort", title: "Порядок" },
        { name: "__slot:actions", title: "", width: "120px" },
      ];
    },
  },
  async created() {
    await Promise.all([
      this.$store.dispatch("deliveryTypes/fetchList"),
      this.fetchList(),
    ]);
  },
  methods: {
    ...mapActions("deliverySlots", [
      "fetchList",
      "create",
      "update",
      "delete",
      "sort",
    ]),
    formatTime(t) {
      if (!t) return "—";
      return String(t).substring(0, 5);
    },
    getTypeTitle(id) {
      const t = this.typesList.find((x) => Number(x.id) === Number(id));
      return t ? t.title : "—";
    },
    openCreateModal() {
      this.editId = null;
      this.editItem = null;
      this.showModal = true;
    },
    edit(row) {
      this.editId = row.id;
      this.editItem = { ...row };
      this.showModal = true;
    },
    closeModal() {
      this.showModal = false;
      this.editId = null;
      this.editItem = null;
    },
    async onSubmit(form) {
      try {
        if (this.editId) {
          await this.update({ id: this.editId, ...form });
          this.$notify?.({ type: "success", title: "Сохранено" });
        } else {
          await this.create(form);
          this.$notify?.({ type: "success", title: "Создано" });
        }
        this.closeModal();
      } catch (e) {
        this.$notify?.({
          type: "error",
          title: "Ошибка",
          text: e.response?.data?.message || "Ошибка",
        });
      }
    },
    async remove(id) {
      if (!confirm("Удалить слот?")) return;
      try {
        await this.delete(id);
        this.$notify?.({ type: "success", title: "Удалено" });
      } catch (e) {
        this.$notify?.({
          type: "error",
          title: "Ошибка",
          text: e.response?.data?.message || "Ошибка",
        });
      }
    },
    async moveSlot(row, delta) {
      const sameType = this.list
        .filter(
          (s) => Number(s.delivery_type_id) === Number(row.delivery_type_id)
        )
        .sort((a, b) => a.sort - b.sort);
      const idx = sameType.findIndex((s) => s.id === row.id);
      if (idx < 0) return;
      const newIdx = idx + delta;
      if (newIdx < 0 || newIdx >= sameType.length) return;
      const reordered = [...sameType];
      const [removed] = reordered.splice(idx, 1);
      reordered.splice(newIdx, 0, removed);
      const slotIds = reordered.map((s) => s.id);
      try {
        await this.sort(slotIds);
        this.$notify?.({ type: "success", title: "Порядок обновлён" });
      } catch (e) {
        this.$notify?.({
          type: "error",
          title: "Ошибка",
          text: e.response?.data?.message || "Ошибка",
        });
      }
    },
  },
};
</script>

<style scoped>
.filter-select-wrap {
  min-width: 200px;
}
.filter-select-wrap .va-input__label {
  display: block;
  margin-bottom: 0.25rem;
  font-size: 0.875rem;
}
.form-control--filter {
  width: 100%;
  padding: 0.5rem;
  border: 1px solid #ccc;
  border-radius: 4px;
}
</style>
